import {
  ANALYTICS_REGISTER_MANDATORY_SUPER_PROPS,
  ANALYTICS_SET_PEOPLE_PROPS,
  ANALYTICS_SET_MANDATORY_PEOPLE_PROPS,
  SET_ANALYTICS_ID,
  TRACK_EVENT,
} from '../actions';

/**
 * This middleware sends analytics events from the different component either by the components directly dispatching "TRACK_EVENT" actions
 * or by catching and sending predefined events based on other actions we already have in our app
 */

export default (analyticsManager) => {
  return () => next => action => {
    switch (action.type) {
      case SET_ANALYTICS_ID:
        analyticsManager.setAnalyticsId(action.analyticsId);
        break;

      case ANALYTICS_REGISTER_MANDATORY_SUPER_PROPS:
        analyticsManager.registerMandatorySuperProperties(action.props);
        break;

      case ANALYTICS_SET_MANDATORY_PEOPLE_PROPS:
        analyticsManager.setMandatoryPeopleProperties(action.props);
        break;

      case ANALYTICS_SET_PEOPLE_PROPS:
        analyticsManager.setPeopleProperties(action.props);
        break;

      case TRACK_EVENT: {
        analyticsManager.track(action.event, action.prefix);
        break;
      }
      default:
        break;
    }

    return next(action);
  };
};
